// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../common/Components/IconV5.bs.js");
let Tooltip = require("../common/Components/Tooltip.bs.js");
let IsTouchDevice = require("is-touch-device");
let JsxRuntime = require("react/jsx-runtime");
let VisuallyHidden = require("@reach/visually-hidden").default;

let isTouch = IsTouchDevice();

function SearchPagesSharedComponents$HelperIcon(props) {
  let label = props.label;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(VisuallyHidden, {
        children: label
      }),
      isTouch ? null : JsxRuntime.jsx("span", {
          children: JsxRuntime.jsx(Tooltip.make, {
            label: label,
            children: JsxRuntime.jsx("span", {
              children: JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(IconV5.make, {
                  icon: props.icon,
                  size: 16,
                  className: "text-zinc-500"
                }),
                className: "flex items-center"
              })
            })
          }),
          "aria-hidden": true
        })
    ]
  });
}

let HelperIcon = {
  isTouch: isTouch,
  make: SearchPagesSharedComponents$HelperIcon
};

function SearchPagesSharedComponents$NoMatches(props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("h3", {
      children: props.text,
      className: "text-2xl font-medium leading-8 text-gray-700 text-center"
    }),
    className: "flex flex-col items-center justify-center mx-auto max-w-[500px] min-h-[200px]"
  });
}

let NoMatches = {
  make: SearchPagesSharedComponents$NoMatches
};

function SearchPagesSharedComponents$ResultsInfo(props) {
  let helperIconText = props.helperIconText;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: props.text,
        className: "text-gray-600"
      }),
      helperIconText !== undefined ? JsxRuntime.jsx(SearchPagesSharedComponents$HelperIcon, {
          label: helperIconText,
          icon: "question"
        }) : null
    ],
    className: "flex flex-row gap-2 items-center col-span-1 md:col-span-2 lg:col-span-3"
  });
}

let ResultsInfo = {
  make: SearchPagesSharedComponents$ResultsInfo
};

exports.HelperIcon = HelperIcon;
exports.NoMatches = NoMatches;
exports.ResultsInfo = ResultsInfo;
/* isTouch Not a pure module */
